export default __webpack_public_path__ + "static/media/close.a971547e.svg";